<script lang="ts">
    import TemplateSettingsGeneral from "./TemplateSettingsGeneral.svelte";
    import {_} from 'svelte-i18n';
    import {customerSettings} from '../../../stores/api';
    import SettingsRow from './SettingsRow.svelte';
    import SettingsRowLabel from './SettingsRowLabel.svelte';
    import SettingsRowValue from './SettingsRowValue.svelte';
    import Select from '../../shared/Select.svelte';
    import { AVAILABLE_OVERLOAD_ACTIONS } from './settings';
    import { debug } from '../../../stores/store';
    import { features } from '../../shared/Features/features';

    export let update: () => void;

    let availableOverloadActions = AVAILABLE_OVERLOAD_ACTIONS.map(action => ({id: action, label: $_(action)})).filter(action => action.id != 'return' || $features.feature_add_warehouse_in_the_middle_of_the_route);

</script>


<TemplateSettingsGeneral>
    <div slot="label">{$_('vehicle_limits_route_calculation')}</div>
    <div slot="content">
        <SettingsRow>
            <SettingsRowLabel>
                {$_('what_to_do_with_overload_vehicle_weight_limit')}
            </SettingsRowLabel>
            <SettingsRowValue>
                <Select
                    bind:selected={$customerSettings.vehicle_overload_actions.weight_limit}
                    items={availableOverloadActions}
                    onChange={(s)=>{update(); return true;}}
                />
            </SettingsRowValue>
        </SettingsRow>
        <SettingsRow>
            <SettingsRowLabel>
                {$_('what_to_do_with_overload_vehicle_parcels_limit')}
            </SettingsRowLabel>
            <SettingsRowValue>
                <Select
                    bind:selected={$customerSettings.vehicle_overload_actions.parcel_limit}
                    items={availableOverloadActions}
                    onChange={(s)=>{update(); return true;}}
                />
            </SettingsRowValue>
        </SettingsRow>
    </div>
</TemplateSettingsGeneral>
